
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/image-to-tiff-converter",
      function () {
        return require("private-next-pages/image-to-tiff-converter/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/image-to-tiff-converter"])
      });
    }
  